import { APPSTORE_URL, PLAYSTORE_URL } from "./constants";

export const getClientInfo = (): string | null =>
  localStorage.getItem("clientInfo");

export const isAndroidOS = (): boolean => {
  const clientInfo = getClientInfo() ?? "";
  return (
    clientInfo.toLowerCase().includes("android") ||
    /android/i.test(navigator.userAgent)
  );
};

export const getStoreLink = () =>
  isAndroidOS() ? PLAYSTORE_URL : APPSTORE_URL;
